import { render } from "./Bar_chart.vue?vue&type=template&id=719596a2"
import script from "./Bar_chart.vue?vue&type=script&lang=js"
export * from "./Bar_chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__